import { takeEvery, fork } from 'redux-saga/effects';
import { toast } from 'react-toastify';

function* handleSuccessToast() {
  yield takeEvery(
    (action: any) => action?.meta?.arg?.originalArgs?.meta?.toast?.success && action.type.endsWith('fulfilled'),
    function (action: any) {
      toast.success(action?.meta?.arg?.originalArgs?.meta?.toast?.success ?? 'Success');
    },
  );
}

function* handleErrorToast() {
  yield takeEvery(
    (action: any) => action.payload?.meta?.toast?.error && action.type.endsWith('rejected'),
    function (action: any) {
      toast.error(action?.payload?.meta?.toast?.error);
    },
  );
}

export function* toastSaga() {
  yield fork(handleSuccessToast);
  yield fork(handleErrorToast);
}
